// @core/api/endpoints/signature/list_signature_requests_by_target.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListSignatureRequestsResponse,
} from '../../../types/signature';

const BASE_PATH = '/signature';

/**
 * List signature requests of a target
 * Returns a paginated list of signature requests by target. Supports filtering and sorting.
 */
export async function ListSignatureRequestsByTarget(
  target_type: string,
  target_id: string,
  params?: {
    limit?: string | number | boolean;
    cursor?: string | number | boolean;
    direction?: string | number | boolean;
    sort?: string | number | boolean;
  },
  options?: RequestOptions
): Promise<ListSignatureRequestsResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/targets/:target_type/:target_id/requests`;
  requestPath = requestPath.replace(':target_type', encodeURIComponent(target_type));
  requestPath = requestPath.replace(':target_id', encodeURIComponent(target_id));
  const requestOptions = options;
  return client.get<ListSignatureRequestsResponse>(requestPath, { ...requestOptions, params });
}
